/**
 * Utility functions for working with URL parameters
 */

/**
 * Get a query parameter value from the current URL
 * @param param - The parameter name to retrieve
 * @returns The parameter value or null if not found
 */
export function getQueryParam(param: string): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

/**
 * Check if the showAllRecommendations query parameter is set to true
 * @returns True if showAll=true is present in the URL
 */
export function shouldShowAllRecommendations(): boolean {
  return getQueryParam('showAllRecommendations') === 'true';
}

/**
 * Check if the implementation button should be hidden via URL parameter
 * @returns True if a=0 (hide button), false otherwise (show button)
 */
export function shouldHideImplementationButton(): boolean {
  return getQueryParam('a') === '0';
}
